var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.5888 0 0 3.58885 0 8.00005C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8.00005C16 3.58885 12.4112 0 8 0ZM8 14.5455C4.39079 14.5455 1.45455 11.6092 1.45455 8.00005C1.45455 4.39088 4.39079 1.45455 8 1.45455C11.6092 1.45455 14.5455 4.39088 14.5455 8.00005C14.5455 11.6092 11.6092 14.5455 8 14.5455Z",
    fill: "#365D7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99911 3.37305C7.44061 3.37305 6.98633 3.82768 6.98633 4.38647C6.98633 4.94479 7.44061 5.39899 7.99911 5.39899C8.55753 5.39899 9.01184 4.94479 9.01184 4.38647C9.01184 3.82768 8.55753 3.37305 7.99911 3.37305Z",
    fill: "#365D7E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.61523C7.58043 6.61523 7.24023 6.95541 7.24023 7.37494V11.9333C7.24023 12.3529 7.58043 12.6931 8 12.6931C8.41956 12.6931 8.7597 12.3529 8.7597 11.9333V7.37494C8.7597 6.95541 8.41956 6.61523 8 6.61523Z",
    fill: "#365D7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.bf05a272d74589f30db6f2f89d7d2963.svg";
export { ForwardRef as ReactComponent };